import  React from 'react'





export const NotFound =()=>{
 return (
  <div>
    <h1 className="notfound">Sorry, no movie was found</h1>
  </div>)
}